/**
 * 题型（技能）→ 视频讲解 的映射
 *
 * - subject 对应 videoData.ts 中 SubjectTab.key
 * - series 必须与 videoData.ts 中某个 series 完全一致（用于视频页按子分类定位）
 * - 没有合适讲解视频的技能不在表内（如：珠心算、跟我读拼音），调用方据此不显示入口
 */

export interface VideoTarget {
    subject: string;
    series: string;
}

const MATH = 'math';
const TANGSHI = 'tangshi';
const GUOXUE = 'guoxue';

const MAP: Record<string, VideoTarget> = {
    // —— 数学 ——
    add10: { subject: MATH, series: '十以内 · 基础运算' },
    minus10: { subject: MATH, series: '十以内 · 基础运算' },
    addminus10: { subject: MATH, series: '十以内 · 基础运算' },

    add20: { subject: MATH, series: '凑十法 · 进位加法' },
    add20back: { subject: MATH, series: '凑十法 · 进位加法' },
    myhardadd20: { subject: MATH, series: '凑十法 · 进位加法' },
    addminus20: { subject: MATH, series: '凑十法 · 进位加法' },

    minus20: { subject: MATH, series: '破十法 · 退位减法' },
    minus20back: { subject: MATH, series: '破十法 · 退位减法' },

    add20sigma: { subject: MATH, series: '趣味数学 · 合集' },
    minus20con: { subject: MATH, series: '趣味数学 · 合集' },
    complex: { subject: MATH, series: '趣味数学 · 合集' },
    mixoperator: { subject: MATH, series: '趣味数学 · 合集' },
    mixoperatorx: { subject: MATH, series: '趣味数学 · 合集' },
    add99: { subject: MATH, series: '趣味数学 · 合集' },

    add100: { subject: MATH, series: '一百以内 · 竖式加减' },
    minus100: { subject: MATH, series: '一百以内 · 竖式加减' },
    addminus100: { subject: MATH, series: '一百以内 · 竖式加减' },
    bigplus: { subject: MATH, series: '一百以内 · 竖式加减' },
    twoplus: { subject: MATH, series: '一百以内 · 竖式加减' },

    sby99: { subject: MATH, series: '乘法口诀' },
    by99: { subject: MATH, series: '乘法口诀' },
    by99back: { subject: MATH, series: '乘法口诀' },
    by99backstepping: { subject: MATH, series: '乘法口诀' },
    twoby: { subject: MATH, series: '多位数乘法' },

    divide100: { subject: MATH, series: '除法 · 口算' },
    remainder: { subject: MATH, series: '除法 · 口算' },
    divide100back: { subject: MATH, series: '除法 · 口算' },
    bydivide100: { subject: MATH, series: '除法 · 口算' },

    // —— 唐诗 ——
    ts: { subject: TANGSHI, series: '唐诗动画' },
    followts: { subject: TANGSHI, series: '唐诗动画' },
    fhl: { subject: TANGSHI, series: '唐诗动画' },

    // —— 国学 ——
    szj: { subject: GUOXUE, series: '经典诵读' },
    followszj: { subject: GUOXUE, series: '经典诵读' },
    idioms: { subject: GUOXUE, series: '成语故事' },
    jl: { subject: GUOXUE, series: '成语故事' },
    followdzg: { subject: GUOXUE, series: '弟子规' },
    dzg: { subject: GUOXUE, series: '弟子规' },
    happygx: { subject: GUOXUE, series: '看动画学经典' },
};

// 取某题型的视频讲解目标，无匹配返回 null
export function getVideoTarget(appName: string): VideoTarget | null {
    return MAP[appName] || null;
}

// 生成视频页深链
export function buildVideoLink(target: VideoTarget): string {
    return `/mp/lesson/list?subject=${encodeURIComponent(target.subject)}&series=${encodeURIComponent(target.series)}`;
}
